import React, {useMemo} from 'react';
import {Loading} from "../../common";
import {ChartLp} from "../../charts";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import {ColumnBox, FlexBox} from "../../ui/styled";
import UpArrow from "../../common/TagWithArrow/UpArrow";
import DownArrow from "../../common/TagWithArrow/DownArrow";
import {getDivisionValue, getTierValue} from "../../../function";

const Title = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.color.dark_200};;
`;

const LPText = styled.span`
  font-size: 12px;
  color: ${props => props.theme.color.dark_200};
  line-height: 14px;
`;

const ArrowWrapper = styled.div`
  margin-right: 2px;
`;

const LPBox = styled.div`
  margin-left: 5px;
  background: ${props => props.theme.color.white_201};
  padding: 2px 5px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const LpChartBox = ({loading, chart}) => {
    const {t} = useTranslation();
    const calcDiffValue = (chart) => {
        const league_points = chart.league_points;
        const tierValue = getTierValue(chart.tier);
        if(tierValue < 2900) {
            const divisionValue = getDivisionValue(chart.division);
            return league_points + tierValue + divisionValue;
        }
        return league_points + tierValue
    }
    const diff = useMemo(() => {
        try {
            const firstChart = chart.originalArr[0];
            const lastChart = chart.originalArr.at(-1);
            return calcDiffValue(lastChart) - calcDiffValue(firstChart)

        } catch (e) {
            return 0;
        }
    }, [chart]);

    if (!loading) return (
        <Loading/>
    )
    return (
        <ColumnBox>
            <FlexBox alignItems={'center'} margin={'0 0 12px 0'} height={'auto'}>
                <Title>{t('summoner.recent')} 30{t('summoner.day')}</Title>
                <LPBox >
                    <ArrowWrapper>
                        {diff > 0 ? <UpArrow size={4.5}/> : <DownArrow size={4.5}/>}
                    </ArrowWrapper>
                    <LPText>{diff} LP</LPText>
                </LPBox>
            </FlexBox>
            {!loading ? <Loading/> :
                <ChartLp tierChart={chart} reverse={true} width={280}/>
            }
        </ColumnBox>
    );
};

export default React.memo(LpChartBox);
